import { Tooltip } from '@mui/material';
import styled from 'styled-components';

export const StyledTooltip = styled(Tooltip)`
  display: flex;
`;
